import * as React from "react"
import { Layout, Seo, Container, ListLayout, ListImg } from "@/components"
import ProductBanner from "@/components/product/banner"
import RelatedCards from "@/components/related-cards"
import LinkModule from "@/components/link-module"
import NotFoundPage from "@/pages/404"
import t from "@/constants/wording"
import * as styles from "./product-advantages-detail.module.scss"

type IProps = {
  pageContext: { productAdvantages: ProductAdvantages }
}

const ProductAdvantagesPage: React.FC<IProps> = ({ pageContext }) => {
  const { productAdvantages } = pageContext
  if (!productAdvantages) return <NotFoundPage />

  const { relatedCases = [] } = productAdvantages
  const relatedCasesFormat: RelatedCard[] = relatedCases
    ? relatedCases.map(item => item.customerCase)
    : []
  const { coreValues } = productAdvantages
  return (
    <Layout>
      <Seo
        title={productAdvantages.title}
        description={productAdvantages.title}
        keywords={t("keywords")}
      />
      <ProductBanner className="partnerBanner" text={productAdvantages.title} />
      <div className={styles.productAdvantagesDetail}>
        <Container isSmall={true}>
          <pre className={styles.description}>
            {productAdvantages.description}
          </pre>
          {productAdvantages.features && productAdvantages.features.length > 0 && (
            <ul className={styles.features}>
              {productAdvantages.features.map(features => (
                <li key={features.id}>{features.feature}</li>
              ))}
            </ul>
          )}
          {coreValues && coreValues.length > 0 && (
            <>
              <h2 className={styles.coreValues}>{t("core values")}</h2>
              <ListLayout listData={coreValues}>
                {list => (
                  <div className={styles.coreValuesList}>
                    <div className={styles.logo}>
                      <ListImg imgInfo={list.image} scale={[1, 1]} />
                    </div>
                    <h5>{list.description}</h5>
                  </div>
                )}
              </ListLayout>
            </>
          )}
        </Container>
      </div>
      <RelatedCards
        styleName="left"
        type="case"
        isSmallDetail={true}
        cards={relatedCasesFormat}
        title={<h2>{t("Related customer cases")}</h2>}
        footer={<LinkModule to={"/case"}>{t("View all cases")}</LinkModule>}
      />
    </Layout>
  )
}

export default ProductAdvantagesPage
